// logisticsService.js
import axios from 'axios';

const DELIVERY_API = 'https://backend.maamaas.com/delivery/api';

// Get auth token helper
const getAuthToken = () => {
    return localStorage.getItem("authToken");
};

// ==================== ENUMS ====================
export const ENUMS = {
    vehicleStatus: ['TWO_WHEELER', 'THREE_WHEELER', 'FOUR_WHEELER'],
    vehicleType: ['BIKE', 'SCOOTER', 'EV', 'PASSENGER_AUTO', 'E_CARGO', 'CAR', 'VAN', 'MINI_TRUCK', 'OPEN_TRUCK', 'CONTAINER_TRUCK', 'REFRIGERATOR_TRUCK']
};

// ==================== CREATE LOGISTICS BILLING ====================
export const createLogisticsBilling = async (data) => {
    try {
        const token = getAuthToken();
        const response = await axios.post(
            `${DELIVERY_API}/logistics/billing`,
            data,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Error creating logistics billing:', error);
        throw error;
    }
};

// ==================== GET ALL LOGISTICS BILLING ====================
export const getAllLogisticsBilling = async () => {
    try {
        const token = getAuthToken();
        const response = await axios.get(
            `${DELIVERY_API}/logistics/billing`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Error fetching logistics billing:', error);
        throw error;
    }
};

// ==================== GET LOGISTICS BILLING BY ID ====================
export const getLogisticsBillingById = async (id) => {
    try {
        const token = getAuthToken();
        const response = await axios.get(
            `${DELIVERY_API}/logistics/billing/${id}`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Error fetching logistics billing:', error);
        throw error;
    }
};

// ==================== UPDATE LOGISTICS BILLING ====================
export const updateLogisticsBilling = async (id, data) => {
    try {
        const token = getAuthToken();
        const response = await axios.put(
            `${DELIVERY_API}/logistics/billing/${id}`,
            data,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Error updating logistics billing:', error);
        throw error;
    }
};

// ==================== DELETE LOGISTICS BILLING ====================
export const deleteLogisticsBilling = async (id) => {
    try {
        const token = getAuthToken();
        const response = await axios.delete(
            `${DELIVERY_API}/logistics/billing/${id}`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('❌ Error deleting logistics billing:', error);
        throw error;
    }
};